// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserInitiateAnyUserPasswordResetInitiateAnyUserPasswordResetResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserInitiateAnyUserPasswordResetInitiateAnyUserPasswordResetResponse.attributeTypeMap;
    }
}
AuthenticationV2UserInitiateAnyUserPasswordResetInitiateAnyUserPasswordResetResponse.discriminator = undefined;
AuthenticationV2UserInitiateAnyUserPasswordResetInitiateAnyUserPasswordResetResponse.additionalProperties = false;
AuthenticationV2UserInitiateAnyUserPasswordResetInitiateAnyUserPasswordResetResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=authenticationV2UserInitiateAnyUserPasswordResetInitiateAnyUserPasswordResetResponse.js.map